import { Typography, Button, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { Forms } from "@/types/form";
import { Input } from "@dippi/ui";
import { Styled } from "../styles";
import { yupResolver } from "@hookform/resolvers/yup";
import schemas from "@/utils/schemas";
import { usePasswordResetLink } from "./hooks";
import { log } from "@/utils/logger";
import { useUser } from "@/context/user";
import constant from "@/utils/constant";
import useCountdown from "@/hooks/auth/useCountdown";

const Reset: React.FC = () => {
    const onPasswordResetLink = usePasswordResetLink();
    const { countdown, counting, startCountdown } = useCountdown();

    const { control, handleSubmit } = useForm<Forms["PasswordResetLink"]>({
        resolver: yupResolver(schemas.resetLink),
        defaultValues: { email: "" },
    });

    const setLoading = useUser(state => state.setGlobalLoading);
    const loading = useUser(state => state.globalLoading);

    const onSubmit = async (data: Forms["PasswordResetLink"]) => {
        try {
            setLoading(true);
            await onPasswordResetLink(data), startCountdown();
        } catch (e) {
            log.error(e, "onSubmit");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Styled.Form onSubmit={handleSubmit(async form => await onSubmit(form))}>
            <Grid container rowGap={constant.GRID_SPACING}>
                <Grid item xs={12}>
                    <Typography align="center">
                        Please enter the email address you'd like your password reset information
                        sent to
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Input
                        testId="reset-email-input"
                        name="email"
                        control={control}
                        label="Email"
                        type="email"
                        disabled={loading || counting}
                        tabIndex={1}
                    />
                </Grid>
                {counting ? (
                    <Grid item xs={12}>
                        <Typography textAlign="center">Try again in {countdown} seconds</Typography>
                    </Grid>
                ) : null}
                <Grid item xs={12}>
                    <Button
                        data-testid="reset-password-button"
                        type="submit"
                        fullWidth={true}
                        disabled={loading || counting}
                        disableRipple={true}
                        tabIndex={2}
                    >
                        Reset password
                    </Button>
                </Grid>
            </Grid>
        </Styled.Form>
    );
};

export default Reset;
